export default __webpack_public_path__ + "static/media/Csb.6ad195ed.jfif";